import {FC} from 'react'
import {cn} from 'src/app/utils/cn.utils'
import GIcon from '../../../Icon/GIcon'
import {FormError} from '../FormError'
import {FormTextProps} from './Text.types'

export const FormText: FC<FormTextProps> = ({
  className,
  inputClassName,
  error,
  touched,
  type = 'text',
  prependIcon,
  prependInnerIcon,
  appendIcon,
  appendInnerIcon,
  prependClassname,
  prependInnerClassname,
  appendClassname,
  appendInnerClassname,
  clickPrependIcon,
  clickPrependInnerIcon,
  clickAppendIcon,
  clickAppendInnerIcon,
  prependNode,
  appendNode,
  prefix,
  suffix,
  ...rest
}) => {
  return (
    <div className={className}>
      <div className='relative flex items-center parent-container'>
        {prependNode && <div className={cn('ml-2')}>{prependNode}</div>}
        {prependIcon && (
          <GIcon
            icon={prependIcon}
            className={cn('cursor-pointer mr-2 w-5 h-5', prependClassname)}
            onClick={clickPrependIcon}
          />
        )}
        <div className='relative flex items-center flex-grow'>
          {prependInnerIcon && (
            <GIcon
              icon={prependInnerIcon}
              className={cn('cursor-pointer absolute left-4 w-5 h-5', prependInnerClassname)}
              onClick={clickPrependInnerIcon}
            />
          )}
          {prefix && (
            <div
              data-testid='formtext-prefix'
              className={cn(
                'prefix-element absolute top-0 left-0 bottom-0 min-w-[55px] rounded-l-lg font-medium text-fs-9 bg-neutral-100 flex items-center justify-center border border-neutral-300 px-2',
                {'border-danger-400 focus:border-danger-400': touched && error}
              )}
            >
              {prefix}
            </div>
          )}
          <input
            type={type}
            className={cn(
              {
                'border border-solid border-danger-400 focus:border focus:border-solid focus:border-danger-400':
                  touched && error,
              },
              {'pl-11': prependInnerIcon},
              {'pr-11': appendInnerIcon},
              {'pl-16': prefix},
              {'pr-16': suffix},
              inputClassName
            )}
            {...rest}
          />
          {suffix && (
            <div
              data-testid='formtext-suffix'
              className={cn(
                'prefix-element absolute top-0 right-0 bottom-0 min-w-[55px] rounded-r-lg font-medium text-fs-9 bg-neutral-100 flex items-center justify-center border border-neutral-300 px-2',
                {'border-danger-400 focus:border-danger-400': touched && error}
              )}
            >
              {suffix}
            </div>
          )}
          {appendInnerIcon && (
            <GIcon
              icon={appendInnerIcon}
              className={cn('cursor-pointer absolute right-4 w-5 h-5', appendInnerClassname)}
              onClick={clickAppendInnerIcon}
            />
          )}
        </div>
        {appendIcon && (
          <GIcon
            icon={appendIcon}
            className={cn('cursor-pointer ml-2 w-5 h-5', appendClassname)}
            onClick={clickAppendIcon}
          />
        )}
        {appendNode && <div className={cn('ml-2')}>{appendNode}</div>}
      </div>
      {touched && error && <FormError>{error}</FormError>}
    </div>
  )
}
